import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./User/userSlice";
import alertSlice from "./Alerts/alertSlice";
import applicationSlice from "./Application/applicationSlice";
import storage from 'redux-persist/lib/storage';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, persistReducer, persistStore } from "redux-persist";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { PeerGamingApiSlice } from "./Api/PeerGamingApiSlice";
import { ErrorNotificationMiddleware } from "./Api/ErrorNotifcationMiddleware";

// Local Storage configurations
const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	whitelist: [userReducer.name],
	blacklist: [PeerGamingApiSlice.reducerPath]
}

const rootReducers = combineReducers({
	[userReducer.name]: userReducer.reducer,
	[alertSlice.name]: alertSlice.reducer,
	[applicationSlice.name]: applicationSlice.reducer,
	[PeerGamingApiSlice.reducerPath]: PeerGamingApiSlice.reducer
})

// Uses local storage to persist data between sessions for specific slices of state
const persistedUserReducer = persistReducer(persistConfig, rootReducers);

export const pgStore = configureStore({
	reducer: persistedUserReducer,
	//Adding the RTK custom generated middleware to the store
	middleware: (getDefaultMiddleware) => {
		return getDefaultMiddleware(
			{
				// https://redux-toolkit.js.org/usage/usage-guide
				serializableCheck: { ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER] }
			})
			.concat(PeerGamingApiSlice.middleware).concat(ErrorNotificationMiddleware);
	},

});

export const persistor = persistStore(pgStore);

export type AppDispatch = typeof pgStore.dispatch;
export type RootState = ReturnType<typeof pgStore.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;